import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import BreadcrumbsBanner from "../breadcrumbs";
import SOETCIVILHeader from "./header";

const CIVILBTechStudentshub=()=>{
return (
<Grid container spacing={2}>
{/* <SOETCIVILHeader/>
        <BreadcrumbsBanner bannerUrl={"https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_692/https://www.iimtindia.net/Blog/wp-content/uploads/2021/07/What-is-ECE-Course.jpg"}/>  */}
<Grid item xs={12}>
    <MainTitle title="B. Tech Electronics & Communication Engineering" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Student’s Hub" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The Student's Hub serves as a dedicated space designed to support, engage, and empower our students throughout their academic journey. This comprehensive platform offers access to a wealth of resources, including academic advisories, project collaboration opportunities, and a calendar of events that enrich the student experience. Using hub students can connect with peers, explore interdisciplinary projects, and participate in student-led organizations for innovation and entrepreneurship. The Hub is also a gateway to wellness and support services, ensuring that students have the support they need to thrive both academically and personally. Through workshops, mentorship programs, and networking events, students are encouraged to expand their horizons, develop new skills, and build a strong community of future tech leaders. The Student's Hub is not just about fostering academic excellence; it's about nurturing a supportive, dynamic environment where every student can find their path to success.
    </Typography>
    </Grid>
    </Grid>

)
}
export default CIVILBTechStudentshub;